<template>
  <SloModal :maxWidth="500" :form="false" @dismiss="handleCloseModal">
    <template v-slot:title>
      {{ 'Sign in to subscribe and save' | t }}
    </template>
    <p>
      Existing customers receive {{ product?.subscriptionPercentageDiscount }}% savings with a subscribe and save subscription.
      New customer? <a :href="`/marketplace/auth/login?redirect=${redirect}`">{{ 'Create an account.' | t }}</a>
    </p>
    <div class="mt-lg bg-gray-50 p-md rounded-md">
      <p class="mb-0">{{ 'New customers enjoy these benefits' | t }}</p>
      <ul class="list-disc mt-xs mb-0 pl-0">
        <li>{{ 'Track your Sloan Marketplace orders' | t }}</li>
        <li>{{ 'Save and manage addresses' | t }}</li>
        <li>{{ 'Create, view, and share DesignSpec projects' | t }}</li>
      </ul>
    </div>
    <div class="grid grid-cols-1 gap-md w-100 sm:grid-cols-2 mt-lg">
      <SloButton @click="handleCloseModal" fill="outline">
        {{ 'No Thanks' | t }}
      </SloButton>
      <SloButton :href="`/marketplace/auth/login?redirect=${redirect}`">
        {{ 'Sign in' | t }}
      </SloButton>
    </div>
  </SloModal>
</template>

<script>
import t from '../../main/i18n';
import SloModal from '../../../lib/components/SloModal.vue';
import SloButton from '../../../lib/components/SloButton.vue';

export default {
  name: 'SubscriptionUnauthorizedModal',
  components: {
    SloModal,
    SloButton
  },
  filters: {
    t
  },
  props: {
    product: {type: Object, required: true}
  },
  computed: {
    redirect() {
      return `${window.location.pathname}${window.location.search}`;
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('dismiss');
    }
  }
};
</script>
